import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { Header } from "./Header";
import { version } from "../../package.json";
import { CDN_BASE_URL } from "../Utils/constant";

class LeftMenu extends Component {
  state = {
    hideDashboard: false,
    hideFrankingFee: false,
    hideProcessingFee: false,
    hideLegalValutionFee: false,
    hideRoi: false,
    hideCollateral: false,
    hideDfpMaster: false,
    hideSegmentMaster: false,
    hideProductMaster: false,
    hideLevelMaster: false,
    hideFundingGridMaster: false,
    hideCancelMaster: false,
    hideServiceMaster: false,
    hideVillageMaster: false,
    hideBranchMaster: false,
    hideEmployeeCreation: false,
    hideApproval: false,
    hidePayment: false,
    hideSpokeMaster: false,
    hideWebNotificationMaster: false,
    hideProductCampaign: false,
  };

  componentDidMount() {}

  render() {
    const {
      hideDashboard,
      hideFrankingFee,
      hideProcessingFee,
      hideLegalValutionFee,
      hideRoi,
      hideCollateral,
      hideDfpMaster,
      hideSegmentMaster,
      hideProductMaster,
      hideLevelMaster,
      hideFundingGridMaster,
      hideCancelMaster,
      hideServiceMaster,
      hideVillageMaster,
      hideBranchMaster,
      hideEmployeeCreation,
      hideApproval,
      hidePayment,
      hideSpokeMaster,
      hideWebNotificationMaster,
      hideProductCampaign,
    } = this.state;

    let isMaster = [
      "/master-gold-audit",
      "/master-franking-fee",
      "/master-product-funding-norms",
      "/master-processing-fee",
      "/master-legal-valuation-fee",
      "/master-roi",
      "/master-collateral-ltv",
      "/master-dfp-master",
      "/master-insurance-deduction",
      "/master-income-multiplier",
      "/master-funding",
      "/master-MFGEMI",
      "/Cancel-master",
      "/Service-master",
      "/Village-master",
      "/Cancellation-per-master",
      "/VillageSpoke-master",
      "/Web-Notification-master",
    ].includes(this.props.location.pathname);

    let on_boarding_master = ["/gold-onboarding", "/franchisee-onboarding"].includes(
      this.props.location.pathname
    );
    let approval_master = [
      "/gold-approval-master",
      "/Franchise-approval-master",
    ].includes(this.props.location.pathname);
    let appraiser_listing_master = [
      "/gold-appraiser-master-listing",
      "/Franchise-appraiser-master-listing",
    ].includes(this.props.location.pathname);

    const onlyEmployeeMasterAccess = ["BM", "ZBH", "ZCM", "RBH", "RCM"];
    const onlyUserManagementAccess = ["BM", "ZBH", "ZCM", "RBH", "RCM"];
    const onlyLeaderboardCampaignAccess = ["SH", "PM", "AM", "MISE"];
    const onlyFOEAccess = ["FOE"];
    let userInfo = {};
    try {
      userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    } catch (e) {
      userInfo = {};
    }
    const role = this.props.role || userInfo?.role || userInfo?.roleCode || "notFetched";
    const isAuditor = role === "Auditor";
    const isZAMorHIAorIAI = ["ZAM", "HIA", "IAI"].includes(role);
    const isFOE = role === "FOE";
    return (
      <aside
        className="LeftMenu"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <ul className="dash_ul">
            <div
              style={{ background: "white" }}
              className="row px-3 d-flex justify-content-center"
            >
              <div>
                <img
                  src={CDN_BASE_URL + "/assets/sg-banner.svg"}
                  style={{ height: "100px", width: "auto", padding: 10 }}
                />
              </div>
            </div>
            <div className="text-center p-2 mt-4">
              <h6 style={{ color: "#e88753" }}>Welcome To Sarvagram </h6>
              <h6
                style={{ overflowWrap: "break-word" }}
                className="text-white"
              ></h6>
            </div>
            <div className="custom-hr">
              <hr />
            </div>
            {role !== "notFetched" &&
            !onlyUserManagementAccess.includes(role) &&
            !onlyLeaderboardCampaignAccess.includes(role) &&
            !onlyFOEAccess.includes(role) ? (
              <li style={hideDashboard ? { display: "none" } : null}>
                <NavLink to="/dashboard" activeClassName="active">
                  <i className="fa fa-tachometer fa-lg"></i>
                  <span>Dashboard</span>
                </NavLink>
              </li>
            ) : null}
            {isFOE ? (
              <>
                <li>
                  <NavLink to="/dashboard" activeClassName="active">
                    <i className="fa fa-tachometer fa-lg"></i>
                    <span>Dashboard</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to=""
                    activeClassName="active"
                    data-toggle="collapse"
                    data-target="#collapseOnBoardingMasters"
                    aria-expanded="true"
                    aria-controls="collapseOnBoardingMasters"
                    id="menu-toggle"
                  >
                    <i className="fa fa-users"></i>
                    <span>Onboarding Master</span> &nbsp; &nbsp;
                    <i className="fa fa-chevron-down"></i>
                  </NavLink>
                  <div
                    id="collapseOnBoardingMasters"
                    class={
                      on_boarding_master ? "collapse-show" : "collapse"
                    }
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <li>
                        <NavLink
                          to="/franchisee-onboarding"
                          activeClassName="active"
                        >
                          <i class="fa fa-address-card-o"></i>
                          <span>Franchisee Onboarding</span>
                        </NavLink>
                      </li>
                    </div>
                  </div>
                </li>
                <li>
                  <NavLink
                    to=""
                    activeClassName="active"
                    data-toggle="collapse"
                    data-target="#collapseApprovalMasters"
                    aria-expanded="true"
                    aria-controls="collapseApprovalMasters"
                    id="menu-toggle"
                  >
                    <i className="fa fa-check-square"></i>
                    <span>Approval Master</span> &nbsp; &nbsp;
                    <i className="fa fa-chevron-down"></i>
                  </NavLink>
                  <div
                    id="collapseApprovalMasters"
                    class={approval_master ? "collapse-show" : "collapse"}
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <li>
                        <NavLink
                          to="/Franchise-approval-master"
                          activeClassName="active"
                        >
                          <i class="fa fa-address-card-o"></i>
                          <span>Franchise Approval Master</span>
                        </NavLink>
                      </li>
                    </div>
                  </div>
                </li>
                <li>
                  <NavLink
                    to=""
                    activeClassName="active"
                    data-toggle="collapse"
                    data-target="#collapseOnAppraiserListingMasters"
                    aria-expanded="true"
                    aria-controls="collapseOnAppraiserListingMasters"
                    id="menu-toggle"
                  >
                    <i className="fa fa-list-alt"></i>
                    <span>Appraiser Listing Master</span> &nbsp; &nbsp;
                    <i className="fa fa-chevron-down"></i>
                  </NavLink>
                  <div
                    id="collapseOnAppraiserListingMasters"
                    class={
                      appraiser_listing_master
                        ? "collapse-show"
                        : "collapse"
                    }
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div class="card-body">
                      <li>
                        <NavLink
                          to="/Franchise-appraiser-master-listing"
                          activeClassName="active"
                        >
                          <i class="fa fa-address-card-o"></i>
                          <span>Franchise Appraiser Listing</span>
                        </NavLink>
                      </li>
                    </div>
                  </div>
                </li>
                <li>
                  <NavLink to="/change-password" activeClassName="active">
                    <i className="fas fa-unlock-alt fa-lg"></i>
                    <span>Change Password</span>
                  </NavLink>
                </li>
              </>
            ) : isAuditor ? (
              <li>
                <NavLink
                  to=""
                  activeClassName="active"
                  data-toggle="collapse"
                  data-target="#collapseOnAppraiserListingMasters"
                  aria-expanded="true"
                  aria-controls="collapseOnAppraiserListingMasters"
                  id="menu-toggle"
                >
                  <i className="fa fa-list-alt"></i>
                  <span>Appraiser Listing Master</span> &nbsp; &nbsp;
                  <i className="fa fa-chevron-down"></i>
                </NavLink>
                <div
                  id="collapseOnAppraiserListingMasters"
                  className={
                    appraiser_listing_master ? "collapse-show" : "collapse"
                  }
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                >
                  <div className="card-body">
                    <li>
                      <NavLink
                        to="/Franchise-appraiser-master-listing"
                        activeClassName="active"
                      >
                        <i className="fa fa-address-card-o"></i>
                        <span>Franchise Appraiser Listing</span>
                      </NavLink>
                    </li>
                  </div>
                </div>
              </li>
            ) : isZAMorHIAorIAI ? (
              <li>
                <NavLink
                  to=""
                  activeClassName="active"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                  id="menu-toggle"
                >
                  <i className="fas fa-sitemap"></i>
                  <span>Master</span> &nbsp; &nbsp;
                  <i className="fa fa-chevron-down"></i>
                </NavLink>
                <div
                  id="collapseOne"
                  className="collapse"
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                >
                  <div className="card-body">
                    <li>
                      <NavLink to="/master-gold-audit" activeClassName="active">
                        <i className="fa fa-arrows-h"></i>
                        <span>Gold Audit Master</span>
                      </NavLink>
                    </li>
                  </div>
                </div>
              </li>
            ) : (
              <>
                {role !== "notFetched" &&
                !onlyUserManagementAccess.includes(role) ? (
                  <>
                    {!onlyLeaderboardCampaignAccess.includes(role) ? (
                      <>
                        <li style={hideDashboard ? { display: "none" } : null}>
                          <NavLink
                            to="/role-management"
                            activeClassName="active"
                          >
                            <i className="fas fa-user-tag"></i>
                            <span>Role management</span>
                          </NavLink>
                        </li>

                        <li style={hideDashboard ? { display: "none" } : null}>
                          <NavLink
                            to="/access-management"
                            activeClassName="active"
                          >
                            <i className="fab fa-keycdn fa-lg"></i>
                            <span>Rolewise Access management</span>
                          </NavLink>
                        </li>

                        <li>
                          <NavLink
                            to=""
                            activeClassName="active"
                            data-toggle="collapse"
                            data-target="#collapseMarketingMasters"
                            aria-expanded="true"
                            aria-controls="collapseMarketingMasters"
                            id="menu-toggle"
                          >
                            <i className="fas fa-sitemap"></i>
                            <span>Marketing Master</span> &nbsp; &nbsp;
                            <i className="fa fa-chevron-down"></i>
                          </NavLink>
                          <div
                            id="collapseMarketingMasters"
                            class={
                              approval_master ? "collapse-show" : "collapse"
                            }
                            aria-labelledby="headingOne"
                            data-parent="#accordion"
                          >
                            <div class="card-body">
                              <li>
                                <NavLink
                                  to="/campaign-medium"
                                  activeClassName="active"
                                >
                                  <i class="fa fa-address-card-o"></i>
                                  <span>Campaign Medium Master</span>
                                </NavLink>
                              </li>
                              <li>
                                <NavLink
                                  to="/campaign-name"
                                  activeClassName="active"
                                >
                                  <i class="fa fa-address-card-o"></i>
                                  <span>Campaign Name Master</span>
                                </NavLink>
                              </li>
                            </div>
                          </div>
                        </li>
                      </>
                    ) : null}
                    <li>
                      <NavLink
                        to=""
                        activeClassName="active"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        id="menu-toggle"
                      >
                        <i className="fas fa-sitemap"></i>
                        <span>Master</span> &nbsp; &nbsp;
                        <i className="fa fa-chevron-down"></i>
                      </NavLink>
                      <div
                        id="collapseOne"
                        className={isMaster ? "collapse" : "collapse"}
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          {isZAMorHIAorIAI && (
                            <li
                              style={
                                hideProductCampaign ? { display: "none" } : null
                              }
                            >
                              <NavLink
                                to="/master-gold-audit"
                                activeClassName="active"
                              >
                                <i class="fa fa-arrows-h"></i>
                                <span>Gold Audit Master</span>
                              </NavLink>
                            </li>
                          )}

                          <li
                            style={
                              hideServiceMaster ? { display: "none" } : null
                            }
                          >
                            <NavLink
                              to="/Service-master"
                              activeClassName="active"
                            >
                              <i class="fa fa-arrows-h"></i>
                              <span>Implement Inventory Master</span>
                            </NavLink>
                          </li>

                          <li
                            style={
                              hideVillageMaster ? { display: "none" } : null
                            }
                          >
                            <NavLink
                              to="/Cancellation-per-master"
                              activeClassName="active"
                            >
                              <i class="fa fa-arrows-h"></i>
                              <span>Cancellation Percentage Master</span>
                            </NavLink>
                          </li>

                          <li
                            style={
                              hideWebNotificationMaster
                                ? { display: "none" }
                                : null
                            }
                          >
                            <NavLink
                              to="/Web-Notification-master"
                              activeClassName="active"
                            >
                              <i class="fa fa-arrows-h"></i>
                              <span>Website Notification Master</span>
                            </NavLink>
                          </li>
                        </div>
                      </div>
                    </li>

                    <li>
                      <NavLink
                        to=""
                        activeClassName="active"
                        data-toggle="collapse"
                        data-target="#collapseOneEmployeeMaster"
                        aria-expanded="true"
                        aria-controls="collapseOneEmployeeMaster"
                        id="menu-toggle"
                      >
                        <i className="fas fa-sitemap"></i>
                        <span>Employee Master</span> &nbsp; &nbsp;
                        <i className="fa fa-chevron-down"></i>
                      </NavLink>
                      <div
                        id="collapseOneEmployeeMaster"
                        className={isMaster ? "collapse" : "collapse"}
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <li
                            style={
                              hideEmployeeCreation ? { display: "none" } : null
                            }
                          >
                            <NavLink
                              to="/employee-creation"
                              activeClassName="active"
                            >
                              <i class="fa fa-arrows-h"></i>
                              <span>Employee Creation</span>
                            </NavLink>
                          </li>
                        </div>
                      </div>
                    </li>

                    <li>
                      <NavLink
                        to=""
                        activeClassName="active"
                        data-toggle="collapse"
                        data-target="#collapseOneGeographyMaster"
                        aria-expanded="true"
                        aria-controls="collapseOneGeographyMaster"
                        id="menu-toggle"
                      >
                        <i className="fas fa-sitemap"></i>
                        <span>Geography Master</span> &nbsp; &nbsp;
                        <i className="fa fa-chevron-down"></i>
                      </NavLink>
                      <div
                        id="collapseOneGeographyMaster"
                        className={isMaster ? "collapse" : "collapse"}
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <li
                            style={
                              hideBranchMaster ? { display: "none" } : null
                            }
                          >
                            <NavLink
                              to="/Branch-master"
                              activeClassName="active"
                            >
                              <i class="fa fa-arrows-h"></i>
                              <span>Branch Master</span>
                            </NavLink>
                          </li>
                          <li
                            style={hideSpokeMaster ? { display: "none" } : null}
                          >
                            <NavLink
                              to="/spoke-master"
                              activeClassName="active"
                            >
                              <i class="fa fa-arrows-h"></i>
                              <span>Spoke Master</span>
                            </NavLink>
                          </li>
                        </div>
                      </div>
                    </li>

                    <li>
                      <NavLink
                        to=""
                        activeClassName="active"
                        data-toggle="collapse"
                        data-target="#collapseOnBoardingMasters"
                        aria-expanded="true"
                        aria-controls="collapseOnBoardingMasters"
                        id="menu-toggle"
                      >
                        <i className="fa fa-users"></i>
                        <span>Onboarding Master</span> &nbsp; &nbsp;
                        <i className="fa fa-chevron-down"></i>
                      </NavLink>
                      <div
                        id="collapseOnBoardingMasters"
                        class={
                          on_boarding_master ? "collapse-show" : "collapse"
                        }
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <li>
                            <NavLink
                              to="/gold-onboarding"
                              activeClassName="active"
                            >
                              <i class="fa fa-address-card-o"></i>
                              <span>Gold Appraiser Onboarding</span>
                            </NavLink>
                          </li>

                          <li>
                            <NavLink
                              to="/franchisee-onboarding"
                              activeClassName="active"
                            >
                              <i class="fa fa-address-card-o"></i>
                              <span>Franchisee Onboarding</span>
                            </NavLink>
                          </li>
                        </div>
                      </div>
                    </li>
                    <li>
                      <NavLink
                        to=""
                        activeClassName="active"
                        data-toggle="collapse"
                        data-target="#collapseApprovalMasters"
                        aria-expanded="true"
                        aria-controls="collapseApprovalMasters"
                        id="menu-toggle"
                      >
                        <i className="fa fa-check-square"></i>
                        <span>Approval Master</span> &nbsp; &nbsp;
                        <i className="fa fa-chevron-down"></i>
                      </NavLink>
                      <div
                        id="collapseApprovalMasters"
                        class={approval_master ? "collapse-show" : "collapse"}
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <li>
                            <NavLink
                              to="/gold-approval-master"
                              activeClassName="active pb-2 pl-0 pr-0"
                              style={{ whiteSpace: "pre" }}
                            >
                              <i class="fa fa-address-card-o"></i>
                              <span>Gold Appraiser Approval Master</span>
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="/Franchise-approval-master"
                              activeClassName="active"
                            >
                              <i class="fa fa-address-card-o"></i>
                              <span>Franchise Approval Master</span>
                            </NavLink>
                          </li>
                        </div>
                      </div>
                    </li>
                    <li>
                      <NavLink
                        to=""
                        activeClassName="active"
                        data-toggle="collapse"
                        data-target="#collapseOnAppraiserListingMasters"
                        aria-expanded="true"
                        aria-controls="collapseOnAppraiserListingMasters"
                        id="menu-toggle"
                      >
                        <i className="fa fa-list-alt"></i>
                        <span>Appraiser Listing Master</span> &nbsp; &nbsp;
                        <i className="fa fa-chevron-down"></i>
                      </NavLink>
                      <div
                        id="collapseOnAppraiserListingMasters"
                        class={
                          appraiser_listing_master
                            ? "collapse-show"
                            : "collapse"
                        }
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <li>
                            <NavLink
                              to="/gold-appraiser-master-listing"
                              activeClassName="active"
                            >
                              <i class="fa fa-address-card-o"></i>
                              <span>Gold Appraiser Listing</span>
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="/Franchise-appraiser-master-listing"
                              activeClassName="active"
                            >
                              <i class="fa fa-address-card-o"></i>
                              <span>Franchise Appraiser Listing</span>
                            </NavLink>
                          </li>
                        </div>
                      </div>
                    </li>
                    <li>
                      <NavLink to="/change-password" activeClassName="active">
                        <i className="fas fa-unlock-alt fa-lg"></i>
                        <span>Change Password</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/CreateCampaign" activeClassName="active">
                        <i className="fa fa-bell"></i>
                        <span>Leaderboard Campaign Master</span>
                      </NavLink>
                    </li>
                  </>
                ) : (
                  <></>
                )}
              </>
            )}
          </ul>
        </div>
        <div
          className="text-center text-white"
          style={{ paddingBottom: "20px" }}
        >
          Version: {version}
        </div>
      </aside>
    );
  }
}

export default withRouter(LeftMenu);
